import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InstagramFull from '../../assets/images/share/instagram_full.png';
import TiKTokFull from '../../assets/images/share/tik_tok_full.png';
import EmailShareButton from '../EmailShareButton.jsx';
import FacebookShareButton from '../FacebookShareButton.jsx';
import LinkedinFeedButton from '../LinkedinFeedButton.jsx';
import TelegramShareButton from '../TelegramShareButton.jsx';
import TwitterShareButton from '../TwitterShareButton.jsx';
import WhatsappShareButton from '../WhatsappShareButton.jsx';
import CloseIcon from '../icons/CloseIcon.jsx';
import FullImageShare from './FullImageShare.jsx';

export default function ShareDialog({ open, onClose, validated, onSendEvent, certificate, sharePostTitle }) {
    const { t } = useTranslation();

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                sx={{
                    '& .MuiPaper-root': {
                        padding: 4,
                        borderRadius: '16px',
                        maxWidth: '435px',
                    },
                }}
            >
                <DialogTitle>
                    <Typography component="span" variant="h3">
                        {t('certificate.share.on_networks')}
                    </Typography>
                    <Divider style={{ marginTop: 22, marginBottom: 16 }} />
                    <a onClick={onClose} style={{ position: 'absolute', right: 12, top: 12, cursor: 'pointer' }}>
                        <CloseIcon />
                    </a>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        spacing={1}
                        direction="row"
                        textAlign="center"
                        alignItems="center"
                        alignContent="center"
                    >
                        <Grid item md={6} xs={12}>
                            <LinkedinFeedButton
                                fullIcon
                                onSendEvent={onSendEvent}
                                cert={certificate}
                                disabled={!validated}
                            />
                        </Grid>

                        <Grid item md={6} xs={12}>
                            <TwitterShareButton
                                fullIcon
                                sharePostTitle={sharePostTitle}
                                onSendEvent={onSendEvent}
                                certificate={certificate}
                                validated={validated}
                            />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <FacebookShareButton
                                fullIcon
                                onSendEvent={onSendEvent}
                                certificate={certificate}
                                validated={validated}
                            />
                        </Grid>

                        <Grid item md={6} xs={12}>
                            <WhatsappShareButton
                                onSendEvent={onSendEvent}
                                fullIcon
                                validated={validated}
                                certificate={certificate}
                                sharePostTitle={sharePostTitle}
                            />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <TelegramShareButton
                                fullIcon
                                onSendEvent={onSendEvent}
                                certificate={certificate}
                                validated={validated}
                                sharePostTitle={sharePostTitle}
                            />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <EmailShareButton
                                fullIcon
                                onSendEvent={onSendEvent}
                                certificate={certificate}
                                validated={validated}
                                sharePostTitle={sharePostTitle}
                            />
                        </Grid>
                        <Grid item md={12} xs={12} width={'100%'} my={1}>
                            <Typography variant="body2">{t('certificate.share.prox')}</Typography>
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <FullImageShare img={InstagramFull} />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <FullImageShare img={TiKTokFull} />
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
}
